import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { SearchIndex } from '@kanda-libs/ks-frontend-services';

import { selectors } from 'store';

export interface SearchResultsHook {
  tabs?: SearchIndex[];
  index?: SearchIndex;
  hasFetched: boolean;
  onTabClick: (idx: SearchIndex) => void;
}

export default function useSearchResults(): SearchResultsHook {
  const [index, setIndex] = useState<SearchIndex | undefined>();

  const data = useSelector(selectors.infoSearch.getEntity);
  const hasFetched = useSelector(selectors.infoSearch.getHasFetched);

  const tabs = useMemo(() => {
    if (!hasFetched) return undefined;
    return data?.index?.filter((v) => v !== 'enterprise');
  }, [hasFetched, data]);

  const onTabClick = useCallback((idx: SearchIndex) => setIndex(idx), []);

  useEffect(() => {
    if (!tabs) return;
    setIndex(tabs[0]);
  }, [tabs]);

  return {
    tabs,
    index,
    hasFetched,
    onTabClick,
  };
}
